import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import ContentManagement from '../../../components/siteadmin/ContentManagement';
import { restrictUrls } from '../../../helpers/adminPrivileges';

const title = 'Content Management';

export default async function action({ store }) {
    // From Redux Store
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    const adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
    const privileges = store.getState().listSettings && store.getState().listSettings.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }

    // Admin restriction - use privilege 19 (staticContentManagement)
    if (!restrictUrls('/siteadmin/staticpage/management', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }

    return {
        title,
        component: <AdminLayout><ContentManagement title={title} /></AdminLayout>,
    };
};
